export const DEP_TYPE_NUM = {
  webinar: 1, // 直播间
  page: 4, // 单场大会
  series: 5, // 系列会
  website: 6 // 聚合主站
};

// 模块key和i18nkey映射
export const MKEY_I18NKEY_MAP = {
  invite: 'lang.k_183011',
  chat: 'lang.k_183031',
  qa: 'lang.k_183033',
  exam: 'lang.k_183036',
  question: 'lang.k_183038',
  sign_in: 'lang.k_183040',
  lottery: 'lang.k_183042',
  cash_red_packet: 'lang.k_183044',
  code_red_packet: 'lang.k_183046',
  follow_user: 'lang.k_183011',
  file_download: 'lang.k_183050',
  ai_qa: 'lang.k_183057'
};
